// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { buttonColors, sharedButtonStyles } from "@awc/XDL/PreStyle/button";
import { fontConfig } from "@awc/XDL/PreStyle/typography";
import { color, xScreen } from "@awc/XDL/Utilities";
import { FormFieldClickable } from "@insite/mobius/FormField";
import { css } from "styled-components";

export const cludoSeachStyles = css`
    #cludo-search-results {
        b {
            color: ${color("common.ui14")};
        }

        .cludo-search-modal-header #cludo-close {
            ${xScreen("lte", "940")} {
                color: transparent;
            }
        }

        .cludo-search-modal-header #cludo-close button:focus {
            border: 0;
        }

        .cludo-search-modal-body #cludo-load-more {
            border-radius: 8px;

            button {
                border-radius: 8px;
                border-width: 2px;
                text-transform: none;
                color: ${color("common.white")};
                background: ${color(buttonColors.primary.main)};
                border-color: ${color(buttonColors.primary.main)};

                &:focus {
                    background: ${color(buttonColors.primary.focus)};
                    border-color: ${color(buttonColors.primary.focus)};
                }

                &:hover {
                    background: ${color(buttonColors.primary.hover)};
                    border-color: ${color(buttonColors.primary.hover)};
                    color: ${color("common.white")};
                }

                ${sharedButtonStyles}
            }
        }
    }

    #cludo-search-form {
        flex-grow: 1;

        ${FormFieldClickable} {
            height: 40px;
        }

        input.search-input {
            border: 0;
            background-color: ${color("common.ui16")};
            line-height: ${fontConfig.lineHeight.singleLineSmall};
            font-size: ${fontConfig.fontSize.small}px;
            -webkit-appearance: none;
            display: inline-block;
            margin: 0;
            width: 100%;
            padding: 0 8px 0 38px;
            height: 40px;
            color: ${color("text")};

            &:hover {
                border: 1px solid ${color("common.ui8")};
            }

            &:focus {
                border: 1px solid ${color("common.ui9")};
                border-radius: 8px;
            }

            ${xScreen("lte", "sm")} {
                background: ${color("common.ui1")};
            }
        }

        #search_autocomplete {
            top: 40px;
            b {
                color: ${color("common.ui14")};
            }
        }
    }
`;
